import { Outlet, useLocation } from 'react-router-dom'
import { SiteHeader } from './SiteHeader'
import { SiteFooter } from './SiteFooter'

export function SiteLayout() {
  const pathname = useLocation().pathname
  const hideFooter = pathname === '/' || pathname === '/investors'
  return (
    <>
      <a className="skip-link" href="#main-content">Skip to content</a>
      <SiteHeader />
      <main id="main-content"><Outlet /></main>
      {!hideFooter && <SiteFooter />}
    </>
  )
}
